export const BREAKPOINTS = {
  MOBILE: 599,
  TABLET: 1023,
  DESKTOP: 1286,
};

export type DeviceType = 'mobile' | 'tablet' | 'desktop';
